import { Injectable, Type } from "@angular/core";
import { KEY_PERSONNEL_DETAILS_FORM_KEYS } from "./constants";

export interface ModalOptions {
  closeModal? : boolean;
  backdropClosable?: boolean;
  textCancelButton?: string;
  showCancelButton?: boolean;
  showConfirmButton?: boolean;
  textConfrimButton?: string;
  title?: string;
  message?: string;
  messageInfo?: string;
  messageRemaining?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  data?: any;
  headerIconPath?: string;
  resendText?: string;
  resendButtonText?: string;
  email?: string,
  onConfirm?: () => void;
  onCancel?: () => void;
  onBtn2Click?: () => void;
  onActionAddRemove?: (actions: QuickActionItem[]) => void;
  selectedQuickActions?: any;
  linkText?: string,
  linkAction?: ()=>void
}

export interface ModalState {
  component: Type<any> | null;
  isVisible: boolean;
  options?: ModalOptions;
}

export type LanguageOptions = 'en' | 'ar';

export type RuleKey = 'minLength' | 'capital' | 'number' | 'special';

export type PopupType = 'success' | 'error' | 'info' | 'warning' | 'custom';
export type PopupPosition = 'top' | 'bottom' | 'center';

export interface PopupOptions {
  message: string;
  type?: PopupType;
  duration?: number; // ms
  icon?: string;
  position?: PopupPosition;
  size?: 'sm' | 'md' | 'lg';
}

export interface SubStep {
  label: string;
  active?: boolean;
  completed?: boolean;
  expanded?: boolean;
}

export interface Step {
  label: string;
  subSteps?: SubStep[];
}

export interface HeaderDropdownOption {
  label: string;
  iconPath?: string;
  route?: string;
  action?: () => void;
}

export interface HeaderConfig {
  title?: string | null;
  showNotifications?: boolean;
  showRightSection?: boolean;
  dropdownOptions?: HeaderDropdownOption[];
}

export interface MonthYear {
  month: number; // 0-11
  year: number;
}

export type KeyPersonnelFormKey = (typeof KEY_PERSONNEL_DETAILS_FORM_KEYS)[keyof typeof KEY_PERSONNEL_DETAILS_FORM_KEYS];

export interface BillPaymentModal {
  billType?: string;
  newOrSaveBillFlow?: string;
}

export type FilterOptionType = 'radio' | 'check';

export interface FilterOption {
  label: string;
  key: string;
  checked: boolean;
  isDefault?: boolean;
}

export interface FilterCategory {
  category: string;
  type: FilterOptionType; 
  options: FilterOption[];
}

export type FilterOptions = FilterCategory[];

export interface QuickActionItem {
  id: string;
  title: string;
  actionLogo: string;
}

export interface QuickActionGroup {
  type: string;
  label: string;
  actions: QuickActionItem[];
}

export interface CliqDbAction {
  iconPath: string;
  label: string;
  description: string;
  id: "cliqManageId" | "cliqBeneficiaries" | "cliqPay";
}

export interface Beneficiary {
  fullName: string;
  mobile: string;
  isFavourite?: boolean;
  id: number
}

@Injectable()
export class CashPushPullData {
  cashPushOrPull?: 'push' | 'pull';
  activeOrHistory?: 'active' | 'history';
}
